//Core
import React from "react"

//Components
import Header from "./Header"
import Blocks from "../../components/Blocks"
import Rules from "./Rules"
import Table from "./Table"
import FooterForm from "./FooterForm"

//Images
import first from "../../images/credit/first.png"
import second from "../../images/credit/second.png"
import third from "../../images/credit/3.png"

const blocks = [
  {
    img: first,
    subtitle: [
      `Позичальники, які не мають простроченої заборгованості станом на 1 березня 2020 року`,
    ],
  },
  {
    img: second,
    subtitle: [
      `Позичальники, у яких прострочена заборгованість станом на 1 березня 2020 року не перевищувала 7-ми днів`,
    ],
  },
  {
    img: third,
    subtitle: [
      `Позичальники, у яких до закінчення терміну дії кредитного договору залишилось не менше 4-х місяців`,
    ],
  },
]

const Credit = () => {
  return (
    <>
      <Header></Header>
      <Blocks
        items={blocks}
        size={"small"}
        title={`Хто може скористатися Кредитними канікулами?`}
      ></Blocks>
      <Rules></Rules>
      <Table></Table>
      <FooterForm></FooterForm>
    </>
  )
}

export default Credit
